import { backofficeRequest } from '../../axios'

export const getFrontTickets = async (ticketId) => {
  try {
    const res = await backofficeRequest.get(
      `backoffice/tickets/${ticketId}/front-tickets`
    )
    return res.data
  } catch (error) {
    return error.response
  }
}

export const unlinkFrontTicket = async (ticketId, frontTicketId) => {
  try {
    return await backofficeRequest.delete(
      `backoffice/tickets/${ticketId}/front-tickets/${frontTicketId}`
    )
  } catch (error) {
    return error.response
  }
}

export const searchFrontTickets = async (query) => {
  try {
    const res = await backofficeRequest.get(
      `backoffice/front/search?query=${query}`
    )
    return res.data
  } catch (error) {
    return error.response
  }
}

export const linkFrontTickets = async (ticketId, frontTickets) => {
  try {
    await backofficeRequest.post(
      `backoffice/tickets/${ticketId}/front-tickets`,
      frontTickets.map((ticket) => ticket.id)
    )
  } catch (error) {
    return error.response
  }
}
